import styled from 'styled-components/native';

export const Container = styled.View``;

export const TextLabel = styled.Text`
  font-family: 'Roboto_400';
  font-size: 13px;
  color: ${props => props.color || props.theme.colors.grayscale.slot6};
`;
